import { RouteItem } from '@eastcoal/router/types/route'

import {
  SUPPLY_DEMAND_DETAIL_PAGE_PATH,
  SUPPLY_DEMAND_EDIT_PAGE_PATH,
  SUPPLY_DEMAND_LIST_PAGE_PATH
} from './constants/path'
import {
  SUPPLY_DEMAND_LIST_PAGE_UUID,
  SUPPLY_DEMAND_ACTION_UUID
} from './constants/uuid'

export const supplyDemandRoute: RouteItem = {
  title: '供需审核',
  hideChildrenInMenu: true,
  uuid: SUPPLY_DEMAND_LIST_PAGE_UUID,
  children: [
    {
      title: '供需审核列表',
      path: SUPPLY_DEMAND_LIST_PAGE_PATH,
      Component: () => import('./List/index')
    },
    {
      title: '供需内容编辑',
      path: SUPPLY_DEMAND_EDIT_PAGE_PATH,
      Component: () => import('./Edit')
    },
    {
      title: '供需内容详情',
      path: SUPPLY_DEMAND_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    },
    {
      title: '管理供需审核',
      uuid: SUPPLY_DEMAND_ACTION_UUID
    }
  ]
}
